var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            height: "50px",
            "line-height": "50px",
            background: "#fff",
            "padding-left": "20px",
            "margin-bottom": "20px",
          },
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              on: { change: _vm.changeTsflag },
              model: {
                value: _vm.form.tsFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "tsFlag", $$v)
                },
                expression: "form.tsFlag",
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.tsFlag")))]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              on: { change: _vm.changeDgCheckFlag },
              model: {
                value: _vm.form.dgCheckFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "dgCheckFlag", $$v)
                },
                expression: "form.dgCheckFlag",
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.dgCheckFlag")))]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              on: { change: _vm.changeDgRfCheckFlagg },
              model: {
                value: _vm.form.rfCheckFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "rfCheckFlag", $$v)
                },
                expression: "form.rfCheckFlag",
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.rfCheckFlag")))]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              on: { change: _vm.changeDgakCheckFlag },
              model: {
                value: _vm.form.akCheckFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "akCheckFlag", $$v)
                },
                expression: "form.akCheckFlag",
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.akCheckFlag")))]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              on: { change: _vm.changeSocCheckFlag },
              model: {
                value: _vm.form.socCheckFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "socCheckFlag", $$v)
                },
                expression: "form.socCheckFlag",
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.socCheckFlag")))]
          ),
          _vm._v(" "),
          _c(
            "el-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.preLockFlag,
              },
              on: { change: _vm.changeHgCheckFlag },
              model: {
                value: _vm.form.hgCheckFlag,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "hgCheckFlag", $$v)
                },
                expression: "form.hgCheckFlag",
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.hgCheckFlag")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.tsFlag
        ? _c("div", { staticClass: "filter-container-content" }, [
            _c("div", { staticClass: "filter-container-title" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("home.tsFlag")))]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled:
                          _vm.preLockFlag ||
                          _vm.adjustVesselFlag ||
                          _vm.isDisable,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handAddVesselInfo(
                            _vm.form.webBkRoutingComs.length
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.addBySchedule")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled:
                          _vm.preLockFlag ||
                          _vm.adjustVesselFlag ||
                          _vm.isDisable,
                      },
                      on: { click: _vm.handleAddTransfer },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.tsFlag")))]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new-back" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: { data: _vm.form.webBkRoutingComs },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        width: "120",
                        label: _vm.$t("home.selectVesselTime"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        _vm.preLockFlag ||
                                        _vm.adjustVesselFlag ||
                                        _vm.isDisable,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handAddVesselLaneInfo(
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Choose Vessel")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2910902165
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "tripNumber" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".tripNumber",
                                        rules: _vm.rules.tripNumber,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 99,
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        model: {
                                          value: scope.row.tripNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "tripNumber",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.tripNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          699423191
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.tripNumber"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "lineType" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".lineType",
                                        rules: _vm.rules.lineType,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.preLockFlag ||
                                              _vm.adjustVesselFlag,
                                          },
                                          on: {
                                            focus: function ($event) {
                                              return _vm.handleFocus(
                                                scope.$index
                                              )
                                            },
                                            change: _vm.changeLine,
                                          },
                                          model: {
                                            value: scope.row.lineType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "lineType",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.lineType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.lineTypeList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.labelZh
                                                    : item.labelEh,
                                                value: Number(item.value),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          787875832
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.lineType"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "serviceLineCode" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".serviceLineCode",
                                        rules: _vm.rules.serviceLineCode,
                                      },
                                    },
                                    [
                                      _c("glRoute", {
                                        attrs: {
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        model: {
                                          value: scope.row.serviceLineCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "serviceLineCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.serviceLineCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3777226886
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.route"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "vesselCode", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "iconbox",
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".vesselCode",
                                        rules: _vm.rules.vesselCode,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          directives: [
                                            {
                                              name: "byte-length",
                                              rawName: "v-byte-length",
                                              value: 6,
                                              expression: "6",
                                            },
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase",
                                            },
                                          ],
                                          attrs: {
                                            onblur:
                                              "this.value = this.value.toUpperCase()",
                                            disabled:
                                              _vm.preLockFlag ||
                                              _vm.adjustVesselFlag,
                                          },
                                          model: {
                                            value: scope.row.vesselCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "vesselCode",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.vesselCode",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              " el-input__icon el-icon-search ",
                                            attrs: { slot: "prefix" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handAddVesselLaneInfo(
                                                  scope.$index
                                                )
                                              },
                                            },
                                            slot: "prefix",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4040806284
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.vesselCode"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "vesselName", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".vesselName",
                                        rules: _vm.rules.tripNumber,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 50,
                                            expression: "50",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        model: {
                                          value: scope.row.vesselName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "vesselName",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.vesselName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2285676969
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.vesselNameCopy"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "voyageNo", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".voyageNo",
                                        rules: _vm.rules.voyageNo,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 10,
                                            expression: "10",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        model: {
                                          value: scope.row.voyageNo,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "voyageNo", $$v)
                                          },
                                          expression: "scope.row.voyageNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          341788471
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.voyageNo"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "voyageLeg", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".voyageLeg",
                                        rules: _vm.rules.voyageNo,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 5,
                                            expression: "5",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        model: {
                                          value: scope.row.voyageLeg,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "voyageLeg",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.voyageLeg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3981320215
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.voyageLeg"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "portFrom", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".portFrom",
                                        rules: _vm.rules.portFrom,
                                      },
                                    },
                                    [
                                      _c("glPort", {
                                        attrs: {
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.handleFocus(scope.$index)
                                          },
                                          change: _vm.changePortFrom,
                                        },
                                        model: {
                                          value: scope.row.portFrom,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "portFrom", $$v)
                                          },
                                          expression: "scope.row.portFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1358041655
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.portFrom"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "portTo", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".portTo",
                                        rules: _vm.rules.portTo,
                                      },
                                    },
                                    [
                                      _c("glPort", {
                                        attrs: {
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.handleFocus(scope.$index)
                                          },
                                          change: _vm.changePortTo,
                                        },
                                        model: {
                                          value: scope.row.portTo,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "portTo", $$v)
                                          },
                                          expression: "scope.row.portTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          5704663
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.portTo"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "saillingDate",
                        label: _vm.$t("home.saillingDate"),
                        width: "130",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "picker-options": _vm.pickerOptions,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "datetime",
                                        disabled:
                                          _vm.preLockFlag ||
                                          _vm.adjustVesselFlag,
                                      },
                                      model: {
                                        value: scope.row.etd,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "etd", $$v)
                                        },
                                        expression: "scope.row.etd",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2344385891
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "etd",
                        label: _vm.$t("home.etdTo"),
                        width: "130",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "picker-options": _vm.pickerOptions,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "datetime",
                                        disabled:
                                          _vm.preLockFlag ||
                                          _vm.adjustVesselFlag,
                                      },
                                      model: {
                                        value: scope.row.eta,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "eta", $$v)
                                        },
                                        expression: "scope.row.eta",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4081418118
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkRoutingComs." +
                                          scope.$index +
                                          ".carrier",
                                        rules: _vm.rules.carrier,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 100,
                                            expression: "100",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled:
                                            _vm.preLockFlag ||
                                            _vm.adjustVesselFlag,
                                        },
                                        model: {
                                          value: scope.row.carrier,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "carrier", $$v)
                                          },
                                          expression: "scope.row.carrier",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2194078729
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.carrier"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "polYard", label: _vm.$t("home.polYard") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("glPort", {
                                      attrs: {
                                        disabled:
                                          _vm.preLockFlag ||
                                          _vm.adjustVesselFlag,
                                      },
                                      model: {
                                        value: scope.row.polYard,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "polYard", $$v)
                                        },
                                        expression: "scope.row.polYard",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3066582341
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "podYard", label: _vm.$t("home.podYard") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("glPort", {
                                      attrs: {
                                        disabled:
                                          _vm.preLockFlag ||
                                          _vm.adjustVesselFlag,
                                      },
                                      model: {
                                        value: scope.row.podYard,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "podYard", $$v)
                                        },
                                        expression: "scope.row.podYard",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1175312973
                      ),
                    }),
                    _vm._v(" "),
                    _vm.isFeed
                      ? _c("el-table-column", {
                          attrs: { width: "30px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      attrs: {
                                        hidden:
                                          _vm.preLockFlag ||
                                          _vm.adjustVesselFlag,
                                      },
                                      on: {
                                        click: function ($event) {
                                          !_vm.showdisabled &&
                                            _vm.handleRemoveTransfer(
                                              scope.row,
                                              scope.$index
                                            )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2537131176
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.form.dgCheckFlag
        ? _c("div", { staticClass: "filter-container-content" }, [
            _c("div", { staticClass: "filter-container-title" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("home.dgCheckFlag")))]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled: _vm.preLockFlag,
                      },
                      on: { click: _vm.handleAddTransferNew },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.dgCheckFlag")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      staticClass: "box el-icon-plus",
                      attrs: { hidden: _vm.preLockFlag },
                      on: { click: _vm.handleAddFile },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.uploadFile")))]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new-back" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: { data: _vm.form.webBkImoComs },
                  },
                  [
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "classType", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".classType",
                                        rules: _vm.rules.classType,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 40,
                                            expression: "40",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.classType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "classType",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.classType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1501765887
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.imoClass"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "unSeriseNo" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".unSeriseNo",
                                        rules: _vm.rules.unSeriseNo,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 100,
                                            expression: "100",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.unSeriseNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "unSeriseNo",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.unSeriseNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3691226440
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.unNo"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "label", label: "Label" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 200,
                                          expression: "200",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.label,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "label", $$v)
                                        },
                                        expression: "scope.row.label",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1156309368
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "packageDesc", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".packageDesc",
                                        rules: _vm.rules.packageDesc,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.packageDesc,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "packageDesc",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.packageDesc",
                                          },
                                        },
                                        _vm._l(
                                          _vm.packageDescList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.codeValue,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.displayValueCn
                                                    : item.displayValue,
                                                value: item.codeValue,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1866191957
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.packageDesc"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "packageCode", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".packageCode",
                                        rules: _vm.rules.packageCode,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.packageCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "packageCode",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.packageCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.packageTypeList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.packageCode,
                                              attrs: {
                                                label: item.packageName,
                                                value: item.packageCode,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          144287123
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.packageType"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "property", width: "156" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".property",
                                        rules: _vm.rules.property,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 1000,
                                            expression: "1000",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.property,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "property", $$v)
                                          },
                                          expression: "scope.row.property",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2446337326
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.property"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "componentDesc", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".componentDesc",
                                        rules: _vm.rules.componentDesc,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 1000,
                                            expression: "1000",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.componentDesc,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "componentDesc",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.componentDesc",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2587143383
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.componentDesc"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "emergencySeq", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".emergencySeq",
                                        rules: _vm.rules.emergencySeq,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 100,
                                            expression: "100",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.emergencySeq,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "emergencySeq",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.emergencySeq",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3488891431
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.emergencySeq"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "emergencyTelNo", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".emergencyTelNo",
                                        rules: _vm.rules.emergencyTelNo,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 400,
                                            expression: "400",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.emergencyTelNo =
                                              scope.row.emergencyTelNo.replace(
                                                /[^0-9\s-]/g,
                                                ""
                                              )
                                          },
                                        },
                                        model: {
                                          value: scope.row.emergencyTelNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "emergencyTelNo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.emergencyTelNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1063796007
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.emergencyTelNo"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "quantity", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".quantity",
                                        rules: _vm.rules.quantity,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 9999999,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.quantity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2108606165
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.imoQuantity"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "grossWeight", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".grossWeight",
                                        rules: _vm.rules.grossWeight,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 2,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 999999.99,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.grossWeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "grossWeight",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.grossWeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          520715329
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.imoGrossWeight"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "netWeight", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".netWeight",
                                        rules: _vm.rules.netWeight,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 2,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 999999.99,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.netWeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "netWeight",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.netWeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2056488708
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.imoNetWeight"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "flashPoint",
                        label: _vm.$t("home.flashPoint"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 2,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 99999999.99,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.flashPoint,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "flashPoint",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.flashPoint",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        185291408
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "rateBase",
                        label: _vm.$t("home.rateBase"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: _vm.preLockFlag },
                                        model: {
                                          value: scope.row.rateBase,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "rateBase", $$v)
                                          },
                                          expression: "scope.row.rateBase",
                                        },
                                      },
                                      _vm._l(_vm.rateBaseList, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label:
                                              _vm.language === "zh"
                                                ? item.labelZh
                                                : item.labelEh,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3772219632
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "isPolutionFlag",
                        label: _vm.$t("home.isPolutionFlag"),
                        width: "125",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: _vm.preLockFlag },
                                        model: {
                                          value: scope.row.isPolutionFlag,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "isPolutionFlag",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.isPolutionFlag",
                                        },
                                      },
                                      _vm._l(_vm.isSplitList, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label:
                                              _vm.language === "zh"
                                                ? item.labelZh
                                                : item.labelEh,
                                            value: Number(item.value),
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2991391350
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "packagingCode", width: "136" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".packagingCode",
                                        rules: _vm.rules.packagingCode,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 10,
                                            expression: "10",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.packagingCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "packagingCode",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.packagingCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          991221275
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.packagingCode"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "packagingCode", width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkImoComs." +
                                              scope.$index +
                                              ".casNo1",
                                            rules: _vm.rules.casNo1,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 0,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 999999,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.casNo1,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "casNo1",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.casNo1",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkImoComs." +
                                              scope.$index +
                                              ".casNo2",
                                            rules: _vm.rules.casNo2,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 0,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 99,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.casNo2,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "casNo2",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.casNo2",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkImoComs." +
                                              scope.$index +
                                              ".casNo1",
                                            rules: _vm.rules.casNo3,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 0,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.casNo3,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "casNo3",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.casNo3",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2886948467
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v("CAS No."),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "cargoSize", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".cargoSize",
                                        rules: _vm.rules.cargoSize,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 3,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 9999999.999,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.cargoSize,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "cargoSize",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.cargoSize",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2716677799
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.cargoSize"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        width: "120",
                        prop: "temperature",
                        label: _vm.$t("home.temperatureOne"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 6,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 9999999.999999,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.temperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "temperature",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.temperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4171375901
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "intakeNum",
                        label: _vm.$t("home.intakeNum"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 20,
                                          expression: "20",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.intakeNum,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "intakeNum", $$v)
                                        },
                                        expression: "scope.row.intakeNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        478234964
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "contactName", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".contactName",
                                        rules: _vm.rules.contactName,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 100,
                                            expression: "100",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.contactName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "contactName",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.contactName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2038012430
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.contactName"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "contactNumber", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".contactNumber",
                                        rules: _vm.rules.contactNumber,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 100,
                                            expression: "100",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.contactNumber =
                                              scope.row.contactNumber.replace(
                                                /[^0-9\s-]/g,
                                                ""
                                              )
                                          },
                                        },
                                        model: {
                                          value: scope.row.contactNumber,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "contactNumber",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.contactNumber",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2388090353
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.contactNumber"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "contactTypeCode", width: "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkImoComs." +
                                          scope.$index +
                                          ".contactTypeCode",
                                        rules: _vm.rules.contactTypeCode,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.contactTypeCode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "contactTypeCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.contactTypeCode",
                                          },
                                        },
                                        _vm._l(
                                          _vm.contactTypeCodeList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.labelZh
                                                    : item.labelEh,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3603633383
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.contactTypeCode"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "approveKey",
                        label: _vm.$t("home.approveKey"),
                        width: "140",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "webBkImoComs." +
                                        scope.$index +
                                        ".approveKey",
                                      rules: _vm.rules.approveKey,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 10,
                                          expression: "10",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.approveKey,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "approveKey", $$v)
                                        },
                                        expression: "scope.row.approveKey",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3368093841
                      ),
                    }),
                    _vm._v(" "),
                    _vm.isFeed
                      ? _c("el-table-column", {
                          attrs: { width: "30px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-form-item", [
                                      _c("i", {
                                        staticClass: "el-icon-remove-outline",
                                        class: { disabled: _vm.showdisabled },
                                        attrs: { hidden: _vm.preLockFlag },
                                        on: {
                                          click: function ($event) {
                                            !_vm.showdisabled &&
                                              _vm.handleremoveTransferNew(
                                                scope.row,
                                                scope.$index
                                              )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3042309477
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.form.rfCheckFlag
        ? _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "filter-container-title" },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("home.rfCheckFlag")))]),
                _vm._v(" "),
                _c("div", { staticClass: "title-box" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }, [
                    _vm._v(_vm._s(_vm.$t("home.ftboxMessage"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      icon: "el-icon-plus",
                      disabled: _vm.preLockFlag,
                    },
                    on: { click: _vm.handleAddwebBkReeferComs },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.rfCheckFlag")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new-back" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: { data: _vm.form.webBkReeferComs },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: _vm.$t("home.No"),
                        width: "60",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "rateBase" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkReeferComs." +
                                          scope.$index +
                                          ".rateBase",
                                        rules: _vm.rules.rateBase,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.rateBase,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "rateBase",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.rateBase",
                                          },
                                        },
                                        _vm._l(
                                          _vm.rateBaseListOne,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.labelZh
                                                    : item.labelEh,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3018800842
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.rateBaseCopy"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "temperature" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkReeferComs." +
                                          scope.$index +
                                          ".temperature",
                                        rules: _vm.rules.temperature,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: _vm.preLockFlag },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.tempBlur(
                                              scope.row.temperature,
                                              scope.$index
                                            )
                                          },
                                        },
                                        nativeOn: {
                                          mousewheel: function ($event) {
                                            $event.preventDefault()
                                          },
                                          input: function ($event) {
                                            return _vm.formatTempNum(
                                              scope.row.temperature,
                                              scope.$index
                                            )
                                          },
                                          keyup: function ($event) {
                                            return _vm.onKeyUp(
                                              scope.row.temperature,
                                              scope.$index
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.temperature,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "temperature",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.temperature",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4152279309
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.temperature"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "maxTemperature",
                        label: _vm.$t("home.maxTemperature"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 9999999,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.maxTemperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "maxTemperature",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.maxTemperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        91338081
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "minTemperature",
                        label: _vm.$t("home.minTemperature"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 9999999,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.minTemperature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "minTemperature",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.minTemperature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        103830975
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "intakeNum" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkReeferComs." +
                                          scope.$index +
                                          ".intakeNum",
                                        rules: _vm.rules.intakeNum,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 20,
                                            expression: "20",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                          { name: "trim", rawName: "v-trim" },
                                          { name: "fth", rawName: "v-fth" },
                                        ],
                                        attrs: {
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          size: "small",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.intakeNum,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "intakeNum",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.intakeNum",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3286295723
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.airvent"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "humidity",
                        label: _vm.$t("home.humidness"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "webBkReeferComs." +
                                        scope.$index +
                                        ".humidity",
                                      rules: _vm.rules.humidity,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 10,
                                          expression: "10",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                        { name: "trim", rawName: "v-trim" },
                                        { name: "fth", rawName: "v-fth" },
                                      ],
                                      attrs: {
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        size: "small",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.humidity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "humidity",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.humidity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2211690440
                      ),
                    }),
                    _vm._v(" "),
                    _vm.isFeed
                      ? _c("el-table-column", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      class: { disabled: _vm.showdisabled },
                                      attrs: { hidden: _vm.preLockFlag },
                                      on: {
                                        click: function ($event) {
                                          !_vm.showdisabled &&
                                            _vm.handleRemovewebBkReeferComs(
                                              scope.row,
                                              scope.$index
                                            )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2540701991
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.form.akCheckFlag
        ? _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "filter-container-title" },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("home.akCheckFlag")))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "title-box",
                    style: { left: _vm.language === "en" ? "200px" : "100px" },
                  },
                  [
                    _c("i", { staticClass: "el-icon-warning-outline" }, [
                      _vm._v(_vm._s(_vm.$t("home.ftboxMessageOne"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      icon: "el-icon-plus",
                      disabled: _vm.preLockFlag,
                    },
                    on: { click: _vm.handleAddrfCheck },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.akCheckFlag")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new-back" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: { data: _vm.form.webBkAkComs },
                  },
                  [
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "containerType", width: "140" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkAkComs." +
                                          scope.$index +
                                          ".containerType",
                                        rules: _vm.rules.containerType,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.containerType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "containerType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.containerType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.containerTypeList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: String(item),
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          767370649
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.containerType"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "unit", width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".akLength",
                                            rules: _vm.rules.akLength,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 2,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999.99,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.akLength,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "akLength",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.akLength",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".akWidth",
                                            rules: _vm.rules.akWidth,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 2,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999.99,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.akWidth,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "akWidth",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.akWidth",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".akHigth",
                                            rules: _vm.rules.akHigth,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 2,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999.99,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.akHigth,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "akHigth",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.akHigth",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1517874479
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.unitTitle"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "akGrossWeight", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkAkComs." +
                                          scope.$index +
                                          ".akGrossWeight",
                                        rules: _vm.rules.akGrossWeight,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 3,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 99999999999.999,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.akGrossWeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "akGrossWeight",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.akGrossWeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2821494059
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.akGrossWeight"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "akNetWeight", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkAkComs." +
                                          scope.$index +
                                          ".akNetWeight",
                                        rules: _vm.rules.akNetWeight,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 3,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 99999999999.999,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.akNetWeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "akNetWeight",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.akNetWeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3600762574
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.akNetWeight"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "quantity" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkAkComs." +
                                          scope.$index +
                                          ".quantity",
                                        rules: _vm.rules.quantity,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 9999999999,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.quantity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2833079885
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.quantityNew"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "commodityName", width: "130" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkAkComs." +
                                          scope.$index +
                                          ".commodityName",
                                        rules: _vm.rules.commodityName,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 500,
                                            expression: "500",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          size: "small",
                                          disabled: _vm.preLockFlag,
                                        },
                                        on: {
                                          input: function ($event) {
                                            scope.row.commodityName =
                                              scope.row.commodityName.replace(
                                                /[^a-zA-Z ]/g,
                                                ""
                                              )
                                          },
                                        },
                                        model: {
                                          value: scope.row.commodityName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "commodityName",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.commodityName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4036327761
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.commodityNameNew"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "unit", width: "420" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".overFront",
                                            rules: _vm.rules.overFront,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 3,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999999.999,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.overFront,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "overFront",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.overFront",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".overAfter",
                                            rules: _vm.rules.overAfter,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 3,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999999.999,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.overAfter,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "overAfter",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "scope.row.overAfter",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".overPortside",
                                            rules: _vm.rules.overPortside,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 3,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999999.999,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.overPortside,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "overPortside",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.overPortside",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".overStarboard",
                                            rules: _vm.rules.overStarboard,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 3,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999999.999,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.overStarboard,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "overStarboard",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.overStarboard",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            prop:
                                              "webBkAkComs." +
                                              scope.$index +
                                              ".overHeight",
                                            rules: _vm.rules.overHeight,
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 3,
                                              "auto-cut": true,
                                              controls: false,
                                              max: 9999999.999,
                                              disabled: _vm.preLockFlag,
                                            },
                                            model: {
                                              value: scope.row.overHeight,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "overHeight",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.overHeight",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          186900092
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.overFront"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "isWallsFold",
                        width: "110",
                        label: _vm.$t("home.isWallsFold"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        "true-label": 1,
                                        "false-label": 0,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.isWallsFold,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "isWallsFold",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.isWallsFold",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        551608418
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "isPointCover",
                        width: "110",
                        label: _vm.$t("home.isPointCover"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-checkbox", {
                                      attrs: {
                                        "true-label": 1,
                                        "false-label": 0,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.isPointCover,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "isPointCover",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.isPointCover",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        84954023
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "stowageRequired",
                        width: "120",
                        label: _vm.$t("home.stowageRequired"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 500,
                                          expression: "500",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.stowageRequired,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "stowageRequired",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.stowageRequired",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1553524075
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "specialLoadRequired",
                        width: "140",
                        label: _vm.$t("home.specialLoadRequired"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 500,
                                          expression: "500",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.specialLoadRequired,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "specialLoadRequired",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.specialLoadRequired",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3901317520
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "securingMethod",
                        width: "130",
                        label: _vm.$t("home.securingMethod"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 200,
                                          expression: "200",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.securingMethod,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "securingMethod",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.securingMethod",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1983869139
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cellphone",
                        width: "100",
                        label: _vm.$t("home.cellphone"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 20,
                                          expression: "20",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.cellphone,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "cellphone", $$v)
                                        },
                                        expression: "scope.row.cellphone",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        487281316
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "other", label: _vm.$t("home.other") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 500,
                                          expression: "500",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.other,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "other", $$v)
                                        },
                                        expression: "scope.row.other",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        947742074
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "oceanFreight",
                        label: _vm.$t("home.oceanFreight"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 3,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 9999999.999,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.oceanFreight,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "oceanFreight",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.oceanFreight",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3935299208
                      ),
                    }),
                    _vm._v(" "),
                    _vm.isFeed
                      ? _c("el-table-column", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      class: { disabled: _vm.showdisabled },
                                      attrs: { hidden: _vm.preLockFlag },
                                      on: {
                                        click: function ($event) {
                                          !_vm.showdisabled &&
                                            _vm.handleRemoveCheck(
                                              scope.row,
                                              scope.$index
                                            )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3692528809
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.form.socCheckFlag
        ? _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "filter-container-title" },
              [
                _c("div", [_vm._v("SOC")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      icon: "el-icon-plus",
                      disabled: _vm.preLockFlag,
                    },
                    on: { click: _vm.handleAddSoc },
                  },
                  [_vm._v("SOC")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new-back" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: {
                      data: _vm.form.webBkSocComs,
                      "header-cell-style": _vm.headFullEmptyType,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: _vm.$t("home.No"),
                        width: "60",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "direction" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkSocComs." +
                                          scope.$index +
                                          ".direction",
                                        rules: _vm.rules.direction,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          on: { change: _vm.judgeDirection },
                                          model: {
                                            value: scope.row.direction,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "direction",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.direction",
                                          },
                                        },
                                        _vm._l(
                                          _vm.directionList,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.codeValue,
                                              attrs: {
                                                label:
                                                  _vm.language === "zh"
                                                    ? item.displayValueCn
                                                    : item.displayValue,
                                                value: Number(item.codeValue),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1305734610
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.direction"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "returnToPort",
                        label: _vm.$t("home.returnToPort"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("glPort", {
                                      attrs: { disabled: _vm.preLockFlag },
                                      on: {
                                        focus: function ($event) {
                                          return _vm.handleGetIndex(
                                            scope.$index
                                          )
                                        },
                                        change: _vm.changeReturnToPort,
                                      },
                                      model: {
                                        value: scope.row.returnToPort,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "returnToPort",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.returnToPort",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3657757112
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: _vm.$t("home.returnToPortName") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 30,
                                          expression: "30",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.returnToPortName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "returnToPortName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.returnToPortName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3446611153
                      ),
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { "min-width": "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkSocComs." +
                                          scope.$index +
                                          ".contactPerson",
                                        rules: _vm.rules.contactPerson,
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "byte-length",
                                            rawName: "v-byte-length",
                                            value: 50,
                                            expression: "50",
                                          },
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          onblur:
                                            "this.value = this.value.toUpperCase()",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.contactPerson,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "contactPerson",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.contactPerson",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3317172424
                        ),
                      },
                      [
                        _vm.form.pol && _vm.form.pol.startsWith("TH")
                          ? _c("template", { slot: "header" }, [
                              _c("span", { staticClass: "required-marker" }, [
                                _vm._v(" *"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "required-marker" }, [
                                _vm._v(_vm._s(_vm.$t("home.contactPerson"))),
                              ]),
                            ])
                          : _c("template", { slot: "header" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("home.contactPerson"))),
                              ]),
                            ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: _vm.$t("home.containerManager") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "byte-length",
                                          rawName: "v-byte-length",
                                          value: 20,
                                          expression: "20",
                                        },
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase",
                                        },
                                      ],
                                      attrs: {
                                        size: "small",
                                        onblur:
                                          "this.value = this.value.toUpperCase()",
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.containerManager,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "containerManager",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.containerManager",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2265022634
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "fullEmptyType",
                        label:
                          _vm.initDirection === 1
                            ? " * " + _vm.$t("home.fullEmptyType")
                            : _vm.$t("home.fullEmptyType"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      id: "soc-item",
                                      prop:
                                        "webBkSocComs." +
                                        scope.$index +
                                        ".fullEmptyType",
                                      rules: _vm.rules.fullEmptyType,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.fullEmptyType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "fullEmptyType",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.fullEmptyType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.fullEmptyTypeList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.codeValue,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.displayValueCn
                                                  : item.displayValue,
                                              value: Number(item.codeValue),
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        353828026
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "containerSize",
                        label: _vm.$t("home.containerSize"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.containerSize,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "containerSize",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.containerSize",
                                        },
                                      },
                                      _vm._l(
                                        _vm.containerSizeList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.codeValue,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.displayValueCn
                                                  : item.displayValue,
                                              value: item.codeValue,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2049078119
                      ),
                    }),
                    _vm._v(" "),
                    _vm.isFeed
                      ? _c("el-table-column", {
                          attrs: { width: "30" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      class: { disabled: _vm.showdisabled },
                                      attrs: { hidden: _vm.preLockFlag },
                                      on: {
                                        click: function ($event) {
                                          !_vm.showdisabled &&
                                            _vm.handleRemoveSoc(
                                              scope.row,
                                              scope.$index
                                            )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2781430352
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.form.hgCheckFlag
        ? _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "filter-container-title" },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("home.hgCheckFlag")))]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      icon: "el-icon-plus",
                      disabled: _vm.preLockFlag,
                    },
                    on: { click: _vm.handleAddHg },
                  },
                  [_vm._v(_vm._s(_vm.$t("home.hgCheckFlag")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-container-new-back" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    attrs: { data: _vm.form.webBkHgComs },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: _vm.$t("home.No"),
                        width: "60",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "containerType" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkHgComs." +
                                          scope.$index +
                                          ".containerType",
                                        rules: _vm.rules.containerType,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { disabled: _vm.preLockFlag },
                                          model: {
                                            value: scope.row.containerType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "containerType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.containerType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.containerTypeList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: String(item),
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2861898556
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.containerTypeCode"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      {
                        attrs: { prop: "quantity" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "webBkHgComs." +
                                          scope.$index +
                                          ".quantity",
                                        rules: _vm.rules.quantity,
                                      },
                                    },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          precision: 0,
                                          "auto-cut": true,
                                          controls: false,
                                          max: 9999999,
                                          disabled: _vm.preLockFlag,
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.quantity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          528538833
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(" *"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "required-marker" }, [
                            _vm._v(_vm._s(_vm.$t("home.quantity"))),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "type", label: _vm.$t("home.type") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: _vm.preLockFlag },
                                        model: {
                                          value: scope.row.type,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "type", $$v)
                                          },
                                          expression: "scope.row.type",
                                        },
                                      },
                                      _vm._l(
                                        _vm.fullEmptyTypeListType,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label:
                                                _vm.language === "zh"
                                                  ? item.labelZh
                                                  : item.labelEh,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3848778734
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "rope", label: _vm.$t("home.rope") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 99999,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.rope,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "rope",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.rope",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1247992625
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "ties", label: _vm.$t("home.ties") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        precision: 0,
                                        "auto-cut": true,
                                        controls: false,
                                        max: 99999,
                                        disabled: _vm.preLockFlag,
                                      },
                                      model: {
                                        value: scope.row.ties,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "ties",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.ties",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1704390866
                      ),
                    }),
                    _vm._v(" "),
                    _vm.isFeed
                      ? _c("el-table-column", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      class: { disabled: _vm.showdisabled },
                                      attrs: { hidden: _vm.preLockFlag },
                                      on: {
                                        click: function ($event) {
                                          !_vm.showdisabled &&
                                            _vm.handleRemoveHg(
                                              scope.row,
                                              scope.$index
                                            )
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2512319872
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("acceesorySitc", {
        ref: "acceesorySitc",
        attrs: {
          width: "50%",
          limitUpload: 2,
          isSupplyDisabled: _vm.isSupplyDisabled,
          fileListArray: _vm.form.webBkImoComFiles,
        },
      }),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChange,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("sailScheduleLane", {
        ref: "sailScheduleLane",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleLaneDialogVisible,
        },
        on: {
          selectionLaneChange: _vm.selectionLaneChange,
          "update:visible": function ($event) {
            _vm.sailScheduleLaneDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("sailScheduleOne", {
        ref: "sailSchedule1",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.bkRoutingSailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChangeOnBkRouting,
          "update:visible": function ($event) {
            _vm.bkRoutingSailScheduleDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }